import { useTranslate } from '@repo/shared/hooks'
import { Col, Typography } from '@repo/ui/components'
import Image from 'next/image'

export const SquareTokenHeroSection = () => {
  const { t, tRich } = useTranslate()

  return (
    <section className='py-5xl sm:py-10xl'>
      <Col className='gap-4xl items-center justify-center'>
        <Image
          src='/images/club-gem.svg'
          alt='square Token Landing'
          className='object-contain w-full h-auto relative z-[1] max-w-[173px] animate-[square-token-spin_1s_ease-out_forwards] origin-center'
          width={173}
          height={173}
        />

        <Col className='gap-3xl items-center justify-center'>
          <Typography
            variant='h1'
            weight='bold'
            className='scale-x-110 sm:scale-x-125 sm:scale-y-110 text-[32px] sm:text-[48px] text-shadow-hero text-center w-full text-neutral-main'
          >
            {tRich.rich('square_token_hero_title', {
              b: (chunks) => (
                <b className='font-black text-[32px] sm:text-[58px]'>
                  {chunks}
                </b>
              ),
            })}
          </Typography>
          <Typography
            variant='h2'
            weight='bold'
            className='text-center w-full text-lg sm:text-2xl text-neutral-main'
          >
            {t('square_token_hero_subtitle')}
          </Typography>
          <Typography
            variant='p'
            className='text-neutral-main text-center text-md max-w-[576px]'
          >
            {t('square_token_hero_desc')}
          </Typography>
        </Col>
      </Col>
    </section>
  )
}
